/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  SWITCH_EDIT_MODE,
  IS_STICKY_NAVBAR_SWIPER,
  SWITCH_CLEAR_ALL_ORDERS,
} from '../../constants/actionType'

/**
 * Declare Variable
 */
const switchEditModeAction = createAction(SWITCH_EDIT_MODE)
const isStickyNavbarSwiperAction = createAction(IS_STICKY_NAVBAR_SWIPER)
const switchClearAllOrdersModeAction = createAction(SWITCH_CLEAR_ALL_ORDERS)
/**
 * Export
 */

export const switchClearAllOrdersMode = (params) => (dispatch) => {
  try {
    dispatch(switchClearAllOrdersModeAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const switchEditMode = (params) => (dispatch) => {
  try {
    dispatch(switchEditModeAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const isStickyNavbarSwiper = (params) => (dispatch) => {
  try {
    dispatch(isStickyNavbarSwiperAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/navbar.js